import { ValidationService } from 'aspnet-client-validation'

// unobtrusive validation
document.addEventListener('DOMContentLoaded', () => {
  // get service
  const validation = new ValidationService()

  // trigger validation lib
  validation.bootstrap({
    addNoValidate: true
  })

  // form button loading state
  const formWithLoadingButton = document.querySelector<HTMLFormElement>(
    'form:has(button[type="submit"][data-loading-button])'
  )

  if (formWithLoadingButton) {
    formWithLoadingButton.addEventListener('submit', () => {
      if (validation.isValid(formWithLoadingButton)) {
        const loadingButtons = formWithLoadingButton.querySelectorAll(
          'button[type="submit"][data-loading-button]'
        )

        loadingButtons.forEach(button => {
          if (!button.hasAttribute('disabled')) {
            button.setAttribute('disabled', 'true')
            button.classList.add('isLoading')

            setTimeout(() => {
              button.removeAttribute('disabled')
              button.classList.remove('isLoading')
            }, 5000)
          }
        })
      }
    })
  }
})

// password helper
document.addEventListener('DOMContentLoaded', () => {
  const helperInput = document.querySelector(
    '[data-password-helper-anchor] input'
  ) as HTMLInputElement
  const helper = document.querySelector('[data-password-helper]') as HTMLElement

  if (!helperInput || !helper) return

  helperInput.addEventListener('input', () => {
    const val = helperInput.value
    checkValidity(val)
  })

  const checkValidity = (val: string) => {
    const rules = [
      { test: /.{6,}/, el: helper.querySelector('[data-validate-length]') },
      { test: /\d/, el: helper.querySelector('[data-validate-numeric]') },
      {
        test: /\p{Lu}/u,
        el: helper.querySelector('[data-validate-uppercase]')
      },
      { test: /\p{Ll}/u, el: helper.querySelector('[data-validate-lowercase]') }
    ]

    rules.forEach(rule => {
      const isValid = rule.test.test(val)

      rule.el?.setAttribute('data-value-valid', String(isValid))
    })
  }
})

// password toggler
document.addEventListener('DOMContentLoaded', () => {
  const togglers = document.querySelectorAll('.password-toggler')

  togglers.forEach(toggler => {
    toggler.addEventListener('click', () => {
      const input = toggler.parentElement?.querySelector(
        'input.password-input'
      ) as HTMLInputElement

      if (!input) return

      if (input.type === 'password') {
        input.type = 'text'
      } else {
        input.type = 'password'
      }
    })
  })
})
